import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Body2, Button } from "@fluentui/react-components";

import { DESKTOP_APP_URL } from "../../../features/notifications/desktop-app/desktop-app-dialog.js";
import { BaseModal } from "./base-modal.jsx";
import type { SharedModalProps } from "./base-modal.jsx";

type SidebarAppWarningModalProps = SharedModalProps;

export const SidebarAppWarningModal = ({
  onClose,
}: SidebarAppWarningModalProps) => {
  const handleInstall = useStableCallback(() => {
    onClose?.();
    window.open(DESKTOP_APP_URL, "_blank", "noopener,noreferrer");
  });

  return (
    <BaseModal
      actionComponent={
        <div className="flex w-full justify-end gap-2">
          <Button appearance="secondary" onClick={onClose} type="button">
            Close
          </Button>
          <Button appearance="primary" onClick={handleInstall} type="button">
            Install Sidebar
          </Button>
        </div>
      }
      mediaComponent={
        <div className="max-h-72 overflow-hidden bg-neutral-100">
          <img
            alt="Preview of the BeZoned Sidebar app"
            className="block h-72 w-full object-cover object-left-top"
            height={640}
            src="/images/sidebar-wide.png"
            width={1280}
          />
        </div>
      }
      title="BeZoned Sidebar"
    >
      <div className="flex flex-col gap-4">
        <Body2>
          The BeZoned Sidebar App gives you a compact panel, where you can see
          who is sitting with you at your table. It stays on top of the other
          programs you're working in, making it easy to see who is nearby and
          interact with them.
        </Body2>
      </div>
    </BaseModal>
  );
};
